'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _colors = require('material-ui/styles/colors');

var _colorManipulator = require('material-ui/utils/colorManipulator');

var _spacing = require('material-ui/styles/spacing');

var _spacing2 = _interopRequireDefault(_spacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRIMARY_BACKGROUND_COLOR = "#305680"; //"#3f51b5";

/*var blueGrayPalette = {
    primary1Color: blueGrey500,
    primary2Color: blueGrey700,
    primary3Color: blueGrey100,
    accent1Color: orange500,
    accent2Color: grey100,
    accent3Color: grey500,
    textColor: grey900,
    secondaryTextColor: grey600,
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey400,
    disabledColor: fade(darkBlack, 0.3),
    pickerHeaderColor: cyan500,
    clockCircleColor: fade(darkBlack, 0.07),
    shadowColor: fullBlack,
};*/

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var indigoPalette = {
    primary1Color: PRIMARY_BACKGROUND_COLOR,
    primary2Color: _colors.indigo700,
    primary3Color: _colors.indigo100,
    accent1Color: _colors.deepOrange500,
    accent2Color: _colors.grey100,
    accent3Color: _colors.grey500,
    textColor: _colors.grey900,
    secondaryTextColor: _colors.grey600,
    alternateTextColor: _colors.white,
    canvasColor: _colors.white,
    borderColor: _colors.grey400,
    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
    pickerHeaderColor: _colors.cyan500,
    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
    shadowColor: _colors.fullBlack
};

exports.default = {
    spacing: _spacing2.default,
    fontFamily: 'Roboto, \'Helvetica Neue\', sans-serif',
    palette: indigoPalette
};


// WEBPACK FOOTER //
// ./src/app/components/react/styles/thingsboardTheme.js